<template>
  <div class="sidebar" :class="centerLayoutClass">
    <LogoHeaderVue />
    <NftSidebarInner v-if="mode === 'NFT-BUY' && !shouldHideNFTSideBarInNFTMode" />
    <MainSidebarInner v-else-if="mode !== 'NFT-BUY'" />
  </div>
</template>

<script setup>
import { toRef, computed, watch, ref } from "vue";
import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";
import { useRoute } from "vue-router";

import LogoHeaderVue from "@/components/layout/LogoHeader.vue";
import MainSidebarInner from "@/components/layout/MainSidebarInner.vue";
import NftSidebarInner from "@/components/layout/nft/NftSidebarInner.vue";

const globalStore = useGlobalStore();
const orderStore = useOrderFormStore();
const shouldHideNFTSideBarInNFTMode = ref(false);
const route = useRoute();
const mode = toRef(orderStore.form, "mode");
const centerLayoutClass = computed(() => {
  if (globalStore.getIsGreyLabel) {
    return "grey-label";
  } 
  if (route.name && hideNFTSideBarInNFTModeRoute.includes(route.name) && orderStore.isNFTMode) {
    return "nft-layout-no-preview"
  }
  if (orderStore.isNFTMode) {
    return "nft-layout"
  }
  return ""
})

const hideNFTSideBarInNFTModeRoute = [
  "error",
  "nft.summary",
]

watch(() => route.name, (routeName) => {
  if (routeName && hideNFTSideBarInNFTModeRoute.includes(route.name) && orderStore.isNFTMode) {
    shouldHideNFTSideBarInNFTMode.value = true;
  }
})

</script>

<style lang="scss">
.sidebar {
  width: 100%;

  @include breakpoint($min-m) {
    overflow-y: hidden;
    max-width: 450px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  @media screen and (min-width: $screen-md) and (max-height: $screen-sm) {
    overflow-y: scroll;
  }
}

.sidebar.grey-label {
  @include breakpoint($min-m) {
    height: 25%
  }

  width: 100%;
  overflow-y: visible;
  max-width: 100%;
  flex-direction: row;
  justify-content: flex-end;
}

.sidebar.nft-layout {
  width: 100%;
  overflow-y: visible;
  max-width: 100%;
  flex-direction: column;
  justify-content: space-between;

  @include breakpoint($min-m) {
    height: 50rem;
  }
}

.sidebar.nft-layout-no-preview {
  width: 100%;
  overflow-y: visible;
  max-width: 100%;
  flex-direction: column;

  @include breakpoint($min-m) {
    height: 25%;
  }
}
</style>
